var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialmediaYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,100L50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.2,59.9V40.1L60.6,50L43.2,59.9z M81.8,33.9c-0.8-2.9-3-5.1-5.9-5.9C70.8,26.6,50,26.6,50,26.6 s-20.8,0-25.9,1.4c-2.9,0.8-5.1,3-5.9,5.9C16.8,39.1,16.8,50,16.8,50s0,10.9,1.4,16.1c0.8,2.9,3,5.1,5.9,5.9 c5.2,1.4,25.9,1.4,25.9,1.4s20.8,0,25.9-1.4c2.9-0.8,5.1-3,5.9-5.9c1.4-5.2,1.4-16.1,1.4-16.1S83.2,39.1,81.8,33.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialmediaYoutube);
export default __webpack_public_path__ + "static/media/icon-socialmedia-youtube.7aa47643ca043cee59ba674b525869fe.svg";
export { ForwardRef as ReactComponent };